module.exports = __webpack_public_path__ + "img/season_sommer.2393721c.svg";